import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { resetFilteringStateAction } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";

import * as ac from "./action-creators";
import { INITIAL_LEADS_SEARCH_FILTERS_STATE } from "./constants";
import type { ILeadsSearchFiltersState } from "./types/state";
import { resolveStateReset, resolveFiltersState } from "./utils/resolvers";

export const leadsSearchFiltersReducer = createReducer<
    ILeadsSearchFiltersState,
    ActionType<typeof ac> | ReturnType<typeof resetFilteringStateAction>
>(INITIAL_LEADS_SEARCH_FILTERS_STATE)
    .handleAction(
        ac.setLeadsFilterValue,
        (state, { payload }): ILeadsSearchFiltersState => ({
            ...state,
            filters: resolveStateReset(state.filters, payload),
        }),
    )
    .handleAction(ac.updateLeadsFilterValue, (state, { payload }): ILeadsSearchFiltersState => {
        const resolvedFilters = resolveFiltersState(state.filters, payload);

        return { ...state, filters: resolvedFilters };
    })
    .handleAction(
        resetFilteringStateAction,
        (state): ILeadsSearchFiltersState => ({
            ...state,
            ...INITIAL_LEADS_SEARCH_FILTERS_STATE,
        }),
    );
